<div *transloco="let t;">
  <app-dialog-title>{{isCreate ? t('settings.add') : t("settings.update")}} {{ t("settings.country")}}</app-dialog-title>

  <mat-dialog-content>
    <div class="content">
      <form [formGroup]="form" class="ui form">
          <div class="field">
              <label>{{ 'settings.country-code' | transloco: {countryAlias} }}</label>
              <input
                formControlName="countryCode"
                class="form-control" />
          </div>
          <div class="field">
            <label>{{ 'settings.country-name' | transloco: {countryAlias} }}</label>
            <input
              formControlName="countryName"
              class="form-control" />
          </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <a class="go-back cancel" (click)="onClose()">{{ 'settings.cancel' | transloco }}</a>
    <button
        [disabled]="form.invalid"
        (click)="save()"
        class="ui primary button">
        {{isCreate ? t('settings.add') : t("settings.update")}}  {{t("settings.country")}}
    </button>
  </mat-dialog-actions>
</div>
